import React from 'react';
import PropTypes from 'prop-types';

import { CloseBtn, ActionBtn, ImageUploader, Form } from '@meronex/components';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useTheme } from '@material-ui/core/styles';

import { makeStyles } from '@material-ui/core/styles';

import StepForm from './StepForm';

import { Icons } from '../../../../common/Icons';

const useStyles = makeStyles((theme) => ({
  container: {},
}));

function EditStepDialog(props) {
  const classes = useStyles();
  const theme = useTheme();

  const { open, onClose, onEditStep } = props;

  const [step, setStep] = React.useState(props.step);

  if (!open) {
    return <div />;
  }
  const _onEdit = () => {
    if (onEditStep) {
      onEditStep(step);
    }
  };
  return (
    <Dialog className={'fullScreenMobile'} open={open} onClose={onClose}>
      <DialogTitle>
        <span
          style={{
            position: 'relative',
            top: '4px',
          }}>
          <Icons.ProcessStep size={25} />
        </span>{' '}
        Edit Process Step
        <CloseBtn
          onClick={() => {
            onClose();
          }}
        />
      </DialogTitle>
      <DialogContent>
        <div>
          <StepForm
            step={step}
            onChange={(step) => {
              setStep({ ...step });
            }}
          />
        </div>
        <div
          style={{
            marginTop: '20px',
            textAlign: 'center',
            marginBottom: '30px',
          }}>
          <ActionBtn label={'Save Step'} onClick={_onEdit} />
        </div>
      </DialogContent>
    </Dialog>
  );
}

EditStepDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onAddStep: PropTypes.func,
};

EditStepDialog.defaultProps = {
  onChange: () => {},
};
export default EditStepDialog;
